import { Card } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const MassiveFormSkeleton = () => (
  <Card className="h-100">
    <Card.Body className="p-3 d-flex flex-column gap-3">
      <div>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <div style={{ width: 220 }}>
            <TextLoading height={14} />
          </div>
          <div style={{ width: 48 }}>
            <TextLoading height={12} />
          </div>
        </div>
        <div className="d-block">
          <TextLoading height={128} />
        </div>
      </div>

      <div className="d-flex gap-2">
        <div className="flex-grow-1">
          <TextLoading height={48} />
        </div>
        <div className="flex-grow-1">
          <TextLoading height={48} />
        </div>
      </div>

      <div className="d-flex align-items-center gap-2">
        <div style={{ width: 48 }}>
          <TextLoading height={14} />
        </div>
        <div style={{ width: 72 }}>
          <TextLoading height={18} />
        </div>
        <div style={{ width: 72 }}>
          <TextLoading height={18} />
        </div>
      </div>

      <div className="d-flex align-items-center gap-2">
        <div style={{ width: 48 }}>
          <TextLoading height={14} />
        </div>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} style={{ width: 28 }}>
            <TextLoading height={28} />
          </div>
        ))}
      </div>

      <div className="d-flex gap-0">
        <div className="flex-grow-1">
          <TextLoading height={38} />
        </div>
        <div className="flex-grow-1">
          <TextLoading height={38} />
        </div>
        <div style={{ width: 104 }}>
          <TextLoading height={38} />
        </div>
      </div>
    </Card.Body>
  </Card>
);

export default MassiveFormSkeleton;
